export type Zone = {
  name: string
  towns: string[]
  delay: string
}

export const zones: Zone[] = [
  {
    name: 'Autour de l’atelier',
    towns: ['Maisons-Laffitte', 'Le Mesnil-le-Roi', 'Sartrouville', 'Le Pecq', 'Saint-Germain-en-Laye'],
    delay: '20 à 30 min',
  },
  {
    name: 'Boucle de Seine',
    towns: ['Poissy', 'Chatou', 'Houilles', 'Bezons', 'Argenteuil', 'Conflans-Sainte-Honorine'],
    delay: '30 à 45 min',
  },
  {
    name: 'Paris et proche banlieue',
    towns: ['Paris 8e à 20e', 'Levallois-Perret', 'Courbevoie', 'Nanterre', 'Colombes'],
    delay: '45 min à 1 h',
  },
]
